<template>
    <div class="page-container has-action">
        <van-nav-bar title="收货地址" left-arrow @click-left="goableBack()"></van-nav-bar>
        <div class="px-20 page ">
            <div v-for="(n,i) of list" :key="i" class="flex-row pt-20 cell-address">
                <div class="left-icon">{{n.receiveName.charAt(0)}}</div>
                <div class="px-10 content">
                    <div class=" fs-16">{{n.receiveName}} <span class="fs-14 ml-10 color-gray-dark">{{n.phone}}</span></div>
                    <div class="fs-12"><van-tag v-if="n.isDefault" class="mr-10" >默认</van-tag>{{`${n.provinceName} ${n.areaName} ${n.cityName} ${n.address}`}}</div>
                </div>
                <div class="right">
                    <van-button :to="{name:'address-edit',params:{id:n.id}}">编辑</van-button>
                </div>
            </div>
        </div>
        <div class="page-action px-20">
            <van-button :to="{name:'address-edit'}" type="danger"  size="large">添加新地址</van-button>
        </div>
    </div>
</template>

<script>
    import { Cell, NavBar, Button, Tag } from "vant";
    import * as GoodsApi from "@/api/goods";
    export default {
        name: "index",
        data:()=>({
            value:'',
            list:[]
        }),
        beforeMount() {
            GoodsApi.placeList().then(data=>{
                this.list = data;
                if(this.$route.query.choose) {
                    this.value = this.$route.query.choose;
                } else if(this.list.length > 0) {
                    let address =  this.list.find(n=>n.isDefault);
                    if(!address) {
                        address = this.list[0]
                    }
                    this.value = address.id;
                }
            }).catch(e=>{

            });
        },
        methods:{

        },
        components: {
            [Cell.name]: Cell,
            [NavBar.name]: NavBar,
            [Button .name]: Button ,
            [Tag .name]: Tag ,
        },
    }
</script>

<style lang="less" scoped>
    .page-container {
        padding-top: 0;
    }
    .cell-address {
        align-items: center;
        .left-icon {
            width: 45px;
            height: 45px;
            text-align: center;
            line-height: 45px;
            border-radius: 50%;
            background: @gray-dark;
            color: #fff;
            font-size: 20px;
        }
        .content {
            flex: 1;
        }
        .van-tag {
            background: #f5dddb;
            color: #cb574d;
        }
        .van-cell__value {

         }
        .right {
            button {
                color: @red;
                margin: 0;
                border: none;
                background: transparent;
            }
        }
    }
</style>